import { createSlice } from '@reduxjs/toolkit';

import { fetchNewInvitationsPostCount } from './NotificationsThunks';

const invitedSubCategories = {
    inProgress: 'In Progress',
    invitedOpportunities: 'Invited Opportunities',
    publicOpportunities: 'Public Opportunities',
};

export const initialState = {
    invitationsPostIds: [],
    personalInvitationsPostIds: [],
    publicInvitationsPostIds: [],
    pendingPostIds: [],
    publishedPostIds: [],
    invitationsPostCount: 0,
    personalInvitationsPostCount: 0,
    publicInvitationsPostCount: 0,
    pendingPostCount: 0,
    publishedPostCount: 0,
    loading: true,
    error: false,
    isInitialized: false,
};

const NotificationsPostsSlice = createSlice({
    name: 'notificationsPosts',
    initialState,
    reducers: {
        decreasePendingPostCount: (state, { payload }) => {
            if (state.pendingPostCount > 0) {
                state.pendingPostIds = state.pendingPostIds.filter(id => id !== payload);
                state.pendingPostCount = state.pendingPostIds.length;
            }
        },
        increasePublicInvitations: (state, { payload }) => {
            state.invitationsPostIds = [payload, ...state.invitationsPostIds];
            state.publicInvitationsPostIds = [payload, ...state.publicInvitationsPostIds];
            state.invitationsPostCount = state.invitationsPostIds.length;
            state.publicInvitationsPostCount = state.publicInvitationsPostIds.length;
        },
        decreaseInvitationsPostCount: (state, { payload }) => {
            switch (payload.subCategoryTitle) {
                case invitedSubCategories.invitedOpportunities:
                    if (state.personalInvitationsPostCount > 0) {
                        state.personalInvitationsPostIds = state.personalInvitationsPostIds.filter(
                            id => id !== payload.id
                        );
                        state.personalInvitationsPostCount =
                            state.personalInvitationsPostIds.length;
                    }
                    break;
                case invitedSubCategories.publicOpportunities:
                    if (state.publicInvitationsPostCount > 0) {
                        state.publicInvitationsPostIds = state.publicInvitationsPostIds.filter(
                            id => id !== payload.id
                        );
                        state.publicInvitationsPostCount = state.publicInvitationsPostIds.length;
                    }
                    break;
                default:
                    break;
            }
        },
        viewPost: (state, { payload }) => {
            state.invitationsPostIds = state.invitationsPostIds.filter(id => id !== payload);
            state.invitationsPostCount = state.invitationsPostIds.length;
        },
        readPost: (state, { payload }) => {
            state.publishedPostIds = state.publishedPostIds.filter(id => id !== payload);
            state.publishedPostCount = state.publishedPostIds.length;
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchNewInvitationsPostCount.pending, state => {
            state.error = false;
            if (state.isInitialized === false) {
                state.loading = true;
            }
        });
        builder.addCase(fetchNewInvitationsPostCount.fulfilled, (state, { payload }) => {
            state.invitationsPostIds = payload.invitationsPostIds;
            state.invitationsPostCount = payload.invitationsPostIds.length;
            state.personalInvitationsPostIds = payload.personalInvitationsPostIds;
            state.personalInvitationsPostCount = payload.personalInvitationsPostIds.length;
            state.publicInvitationsPostIds = payload.publicInvitationsPostIds;
            state.publicInvitationsPostCount = payload.publicInvitationsPostIds.length;
            state.pendingPostIds = payload.pendingPostIds;
            state.pendingPostCount = payload.pendingPostIds.length;
            state.publishedPostIds = payload.publishedPostIds;
            state.publishedPostCount = payload.publishedPostIds.length;
            state.loading = false;
            state.isInitialized = true;
        });
        builder.addCase(fetchNewInvitationsPostCount.rejected, (state, { payload }) => {
            state.error = true;
            state.loading = false;
            alert(payload);
        });
    },
});

export const NotificationsPostsReducer = NotificationsPostsSlice.reducer;
export const NotificationsPostsActions = {
    ...NotificationsPostsSlice.actions,
    fetchNewInvitationsPostCount,
};
